module.exports = __webpack_public_path__ + "img/fineStaff.e488cd5f.png";